// extracted by mini-css-extract-plugin
export default {"root":"PreviewCardLayout__root___yn8k2","topActions":"PreviewCardLayout__topActions___ci54w","footer":"PreviewCardLayout__footer___KDSBx"};